import React from "react";
import logoWhite from "../../assets/images/InceptionFinicallyLogo.png";
import logoBlack from "../../assets/images/InceptionFinicallyLogoBlack.png";
import gradientBg from "../../assets/images/onboardingTemplate.png";

interface AuthSplitLayoutProps {
  children: React.ReactNode;
  subtitle?: string;
}

const AuthSplitLayout = ({
  children,
  subtitle = "Put in your details and we will get you signed in.",
}: AuthSplitLayoutProps) => {
  return (
    <div className="relative flex min-h-screen w-full font-raleway bg-[#0b1a2b]">
      
      <div 
        className="absolute inset-0 z-0 flex flex-col justify-end overflow-hidden bg-[length:100%_auto] bg-left-top bg-no-repeat md:relative md:w-3/5"
        style={{ backgroundImage: `url(${gradientBg})` }}
      >
        <a
          href="https://www.inception.financial/"
          target="_blank"
          rel="noreferrer"
          className="hidden absolute left-10 top-10 md:block"
        >
          <img src={logoWhite} alt="Inception Financial" className="h-14 w-auto" />
        </a>

        <div className="hidden flex-1 flex-col justify-center px-12 text-center md:flex">
          <h1 className="font-['Proxima_Nova',_sans-serif] text-left text-4xl font-light leading-tight text-white lg:text-5xl">
            Welcome to Inception Financial!
          </h1>
          <p className="font-['Proxima_Nova',_sans-serif] mt-4 text-left text-base font-light text-white/70 md:text-xl lg:text-2xl">
            {subtitle}
          </p>
        </div>
      </div>

      <div className="relative z-10 flex w-full flex-col items-center justify-center p-6 md:w-2/5 md:bg-white md:p-10">
        
        <div className="w-full max-w-sm rounded-2xl bg-white p-8 shadow-2xl md:rounded-none md:p-0 md:shadow-none md:bg-transparent">
          
          <div className="mb-6 flex justify-center md:hidden">
            <a
              href="https://www.inception.financial/"
              target="_blank"
              rel="noreferrer"
              className="inline-block"
            >
              <img src={logoBlack} alt="Inception Financial" className="h-14 w-auto" />
            </a>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthSplitLayout;
